import { SET_TAB_DATA, SET_TAB_LOADER, SET_UPDATED_VALUES, SET_SKILLS, SET_SETTINGS, SET_MICROSITES, SET_MICROSITE_ACTIONS, SET_SPONSORS, SET_FULL_PENDING_COUNT, SET_HUB_PENDING_COUNT, SET_FULL_DELETE_REVIEW_COUNT, SET_HUB_DELETE_REVIEW_COUNT,SET_ORG_IMG_URL } from './constants'


export const setTabData = (tabData) => ({
    type: SET_TAB_DATA,
    tabData,
});

export const setTabLoader = (tabLoader) => ({
    type: SET_TAB_LOADER,
    tabLoader,
});

export const setUpdatedValues = (updatedValues) => ({
    type: SET_UPDATED_VALUES,
    updatedValues,
});


export const setSkills = (skills) => ({
    type: SET_SKILLS,
    skills,
});

export const setSettings = (settings) => ({
    type: SET_SETTINGS,
    settings,
});


export const setMicroSites = (microSites) => ({
    type: SET_MICROSITES,
    microSites,
});


export const setMicroSiteActions = (microSiteActions) => ({
    type: SET_MICROSITE_ACTIONS,
    microSiteActions,
});

export const setSponsorList = (sponsors) => ({
    type: SET_SPONSORS,
    sponsors
})

export const setFullPendingCount = (count) => ({
    type: SET_FULL_PENDING_COUNT,
    count
})

export const setHubPendingCount = (count) => ({
    type: SET_HUB_PENDING_COUNT,
    count
})

export const setFullDeleteReviewCount = (count) => ({
    type: SET_FULL_DELETE_REVIEW_COUNT,
    count
})

export const setHubDeleteReviewCount = (count) => ({
    type: SET_HUB_DELETE_REVIEW_COUNT,
    count
})

export const setOrgImageUrl = (url) => ({
    type: SET_ORG_IMG_URL,
    url
})